import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Bored?",
  "description": "",
  "published": "2007-01-25T00:00:00.000Z",
  "redirect_from": ["/blog/bored/swizec/305"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`If you ever get very and severely bored, try becoming an `}<a parentName="p" {...{
        "href": "http://www.beseechfanclub.com/bored/"
      }}>{`animal`}</a>{` to calm yourself.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      